import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function VirtualTour() {
  const [media, setMedia] = useState([]);
  const [locations, setLocations] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    Promise.all([api("/api/gallery/media?media_type=virtual_tour"), api("/api/campus-locations")])
      .then(([tourRows, locationRows]) => {
        setMedia(Array.isArray(tourRows) ? tourRows : []);
        setLocations(Array.isArray(locationRows) ? locationRows.filter((item) => item.virtual_tour_url) : []);
      })
      .catch((err) => setError(err.message));
  }, []);

  const tours = [
    ...media.map((item) => ({ id: `m-${item.id}`, title: item.title, caption: item.caption, url: item.media_url })),
    ...locations.map((item) => ({ id: `l-${item.id}`, title: item.name, caption: item.description, url: item.virtual_tour_url })),
  ];

  return (
    <main className="bg-slate-950 px-4 py-16 text-white">
      <section className="mx-auto max-w-7xl">
        <p className="text-sm font-black uppercase tracking-[0.25em] text-emerald-300">Virtual Experience</p>
        <h1 className="mt-3 text-4xl font-black md:text-6xl">Virtual Campus Tour</h1>
        <p className="mt-4 max-w-3xl text-slate-300">Show visitors important facilities, labs, departments and campus landmarks through video or 360° tour links uploaded from the CMS.</p>
        {error && <div className="mt-6 rounded-xl bg-red-950 p-4 font-semibold text-red-200">{error}</div>}
        <div className="mt-10 grid gap-6 lg:grid-cols-2">
          {tours.map((tour) => (
            <article key={tour.id} className="overflow-hidden rounded-3xl bg-white/10 ring-1 ring-white/10">
              <iframe title={tour.title} src={tour.url} className="h-80 w-full bg-black" allowFullScreen />
              <div className="p-6">
                <h2 className="text-2xl font-black">{tour.title}</h2>
                <p className="mt-2 text-slate-300">{tour.caption || "Official virtual tour media."}</p>
                <a href={tour.url} target="_blank" rel="noreferrer" className="mt-4 inline-flex rounded-xl bg-emerald-600 px-5 py-3 font-bold text-white hover:bg-emerald-700">Open Full Tour</a>
              </div>
            </article>
          ))}
        </div>
        {tours.length === 0 && <div className="mt-10 rounded-3xl bg-white/10 p-10 text-slate-300">No virtual tour has been published yet.</div>}
      </section>
    </main>
  );
}
